import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store'
import {getUrlToken, setToken} from '@/utils/auth'

Vue.use(Router)

const routes = [
    {
        path: '/',
        name: 'index',
        meta: {
            title: '合阳县渔业统计数据大屏'
        },
        component: () => import('@/view/index/index'),
        redirect: '/home',
        children: [
            {
                path: '/home',
                name: 'Home',
                component: () => import('@/view/home/index')
            }
        ]
    },
    {path: '/login', name: 'login', meta: {noLogin: true}, component: () => import('@/view/login/login')},
    // 404 page must be placed at the end !!!
    {path: '*', redirect: '/', hidden: true}
]

const createRouter = () => new Router({
    routes,
    mode: 'hash'
});

const router = createRouter()

router.beforeEach((to, from, next) => {
    const urlToken = getUrlToken()

    if (urlToken && store.state.token !== urlToken) {
        store.commit('setLogin', urlToken)
        setToken(urlToken)
    }

    if (to.meta.noLogin) { //判断该路由是否需要登录权限
        // url中存在token时，不需要进入登录页
        if (to.path === '/login' && (urlToken || store.state.token)) {
            next({path: '/'})
            return
        }
        // 不需要登录
        next()
    } else {
        // 需要登录
        if (urlToken || store.state.token) {
            // 已登录
            next()
        } else {
            // 未登录
            next({
                path: '/login',
                query: {redirect: to.fullPath} //将跳转的路由path作为参数，登陆成功后跳转到该路由
            })
        }
    }
})

export function resetRouter() {
    const newRouter = createRouter()
    router.matcher = newRouter.matcher // reset router
}

export default router;
